module.exports = __webpack_public_path__ + "_assets/img/Frame1202.c7675122.svg";